module.exports = __webpack_public_path__ + "img/verify_1.1fc9e4ab.png";